import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { ArvoreEstilos, NoEstilo, ValorAtributoEdicao } from "src/app/shared/model/arvore-estilos.model";
import { AtributoEstiloSegmento } from "src/app/shared/model/atributo-estilo-segmento.model";
import { EstiloSegmento } from "src/app/shared/model/estilo-segmento.model";
import { SegmentoTela } from "src/app/shared/model/segmento.model";
import { TipoSegmento } from "src/app/shared/model/tipo-segmento.model";

@Component({
    selector: 'app-painel-estilo-segmento',
    templateUrl: './painel-estilo-segmento.component.html',
    styleUrls: ['./painel-estilo-segmento.component.css', '../../../../../src/app/shared/css/contraste.css']
})
export class PainelEstiloSegmentoComponent implements OnInit {

    @Input() tipoSegmentoGlobal: TipoSegmento;
    @Input() tipoSegmento: TipoSegmento;
    @Input() segmento: SegmentoTela;

    @Input() readonly: boolean;
    @Input() modoTipoSegmento = false;
    @Output() aplicarEstiloSegmento: EventEmitter<EstiloSegmento | null> = new EventEmitter<EstiloSegmento | null>();

    // implementa o acesso às 4 variáveis do atributo "padding"
    get recuoSuperior(): string {
        return this.getPaddingPart(0);
    }
    set recuoSuperior(s: string) {
        this.setPaddingPart(0, s);
    }
    get recuoDireito(): string {
        return this.getPaddingPart(1);
    }
    set recuoDireito(s: string) {
        this.setPaddingPart(1, s);
    }
    get recuoInferior(): string {
        return this.getPaddingPart(2);
    }
    set recuoInferior(s: string) {
        this.setPaddingPart(2, s);
    }
    get recuoEsquerdo(): string {
        return this.getPaddingPart(3);
    }
    set recuoEsquerdo(s: string) {
        this.setPaddingPart(3, s);
    }

    getPaddingPart(i: number): string {
        const va = this.vaPadding;
        if (!va) {
            return '';
        }
        let valor = va.herdado;
        if (va.checked) {
            valor = va.setado;
        }
        if (!valor) {
            return '';
        }
        const valores = valor.split(' ');
        return valores[i] ? valores[i] : '';
    }

    setPaddingPart(i: number, s: string) {
        const va = this.vaPadding;
        if (!va) {
            return;
        }
        let valor = '   ';
        if (va.setado) {
            valor = va.setado;
        }
        s = s.replaceAll(' ', '');
        const valores = valor.split(' ');
        valores[i] = s;
        this.vaPadding.setado = valores.join(' ');
    }

    arvoreEstilos: ArvoreEstilos;
    noEstilo: NoEstilo;

    listaVA: ValorAtributoEdicao[];
    vaColor: ValorAtributoEdicao;
    vaFontFamily: ValorAtributoEdicao;
    vaFontSize: ValorAtributoEdicao;
    vaTextTransform: ValorAtributoEdicao;
    vaTextAlign: ValorAtributoEdicao;
    vaFontWeight: ValorAtributoEdicao;
    vaFontStyle: ValorAtributoEdicao;
    vaTextDecoration: ValorAtributoEdicao;
    vaWidth: ValorAtributoEdicao;
    vaPadding: ValorAtributoEdicao;
    vaTextIndent: ValorAtributoEdicao;

    ready = false;

    fontFamilyOptions = [
        'Arial, Helvetica, sans-serif',
        '"Open Sans", arial, sans-serif',
        '"Helvetica Neue", Helvetica, Arial, sans-serif'
    ];

    constructor(
        private router: Router,
    ) {}

    ngOnInit(): void {
        this.ready = false;
        this.arvoreEstilos = new ArvoreEstilos([this.tipoSegmentoGlobal]);
        let no: NoEstilo | null = this.arvoreEstilos.noGlobal;
        if (this.tipoSegmento) {
            no = this.arvoreEstilos.incluirNoTipoSegmento(this.tipoSegmento);
            if (this.segmento && this.segmento.idTipoSegmento) {
                no = this.arvoreEstilos.incluirNoSegmento(this.segmento.idTipoSegmento, this.segmento.estiloSegmento);
            }
        }
        if (!no) {
            return;
        }
        this.noEstilo = no;
        this.vaColor = no.getVA('color', 'Cor');
        this.vaFontFamily = no.getVA('font-family', 'Família de fontes');
        this.vaFontSize = no.getVA('font-size', 'Tamanho');
        this.vaTextTransform = no.getVA('text-transform', 'Caixa da fonte',
                ['sem alteração', 'maiúsculas', 'minúsculas'],
                ['none', 'uppercase', 'lowercase']);
        this.vaTextAlign = no.getVA('text-align', 'Alinhamento do parágrafo',
                ['alinhado à esquerda', 'alinhado à direita', 'centralizado', 'justificado'],
                ['start', 'end', 'center', 'justify']);
        this.vaFontWeight = no.getVA('font-weight', 'Realce da fonte',
                ['normal', 'negrito'],
                ['normal', 'bold']);
        this.vaFontStyle = no.getVA('font-style', 'Inclinação da fonte',
                ['normal', 'itálico'],
                ['normal', 'italic']);
        this.vaTextDecoration = no.getVA('text-decoration', 'Decoração do texto',
                ['normal', 'sublinhado'],
                ['none', 'underline']);
        this.vaWidth = no.getVA('width', 'Largura do parágrafo');
        this.vaPadding = no.getVA('padding', 'Recuo do parágrafo');
        this.vaTextIndent = no.getVA('text-indent', 'Recuo da primeira linha');

        this.listaVA = [this.vaColor, this.vaFontFamily, this.vaFontSize, this.vaTextTransform, this.vaTextAlign,
            this.vaFontWeight, this.vaFontStyle, this.vaTextDecoration, this.vaWidth, this.vaPadding, this.vaTextIndent, this.vaPadding];
        this.ready = true;
    }

    salvar() {
        const estilo = new EstiloSegmento();
        for (const va of this.listaVA) {
            if (va.checked && va.setado) {
                estilo.atributos.push(new AtributoEstiloSegmento(va.atributo, va.setado));
            }
        }
        this.aplicarEstiloSegmento.emit(estilo);
    }

    cancelar() {
        this.aplicarEstiloSegmento.emit(null);
    }
}
